import React, { lazy, Suspense } from 'react';

import { Head as SEO } from '@landing/components';
import Header from 'components/Header';
import { anchorLinks } from 'define/anchorLinks';
import { offices } from 'define/offices';
import Intro from 'components/Intro';
import Team from 'components/Team';
import About from 'components/About';
import Testimonials from 'components/Testimonials';
import Services from 'components/Services';
import Interview from 'components/Interview';
import Offices from 'components/Offices';
import Footer from 'components/Footer';
import CookiesPolicy from 'components/CookiesPolicy';

import data from './data.json';

const ConsentModal = lazy(() =>
  import('components/Modals').then(({ ConsentModal }) => ({
    default: ConsentModal,
  })),
);

export default function Index() {
  const isSsr = typeof window === 'undefined';

  return (
    <>
      <Header anchorLinks={anchorLinks} />
      <Intro {...data.intro} />
      <Team {...data.team} />
      <About {...data.about} projects={data.projects} />
      <Testimonials {...data.testimonials} />
      <Services {...data.services} />
      <Interview {...data.interview} />
      <Offices offices={offices} {...data.offices} />
      <Footer anchorLinks={anchorLinks} {...data.footer} />
      <CookiesPolicy />
      {!isSsr && (
        <Suspense fallback={null}>
          <ConsentModal />
        </Suspense>
      )}
    </>
  );
}

export const Head = () => <SEO {...data.head} />;
